import {LocationPoint} from '@/common/interfaces/location';
import {parseLocationFlags} from '@/common/helpers/location/parseLocationFlags';

export const parseLocationPoint = (location: any): LocationPoint => ({
	id: location.id,
	type: location.type,
	flags: parseLocationFlags(location.flags),
	title: location.title,
	titleLc: location.title_lc,
	titleGc: location.title_gc,
	description: location.description,
});
